import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import { CustomButton } from '../../../../../../components/Button/Button';
import AssignCard from '../../../Kanban/AssignCard';

const AssigneeSection = ({ 
  data, 
  assigneeOptions,
  conditionCheck,
  cardId,
  assignCardMutate,
  currentUserId,
  boardPermission
}) => {
    const assigneeFirstName = data?.assigned_to_user?.first_name[0];
    const assigneeLastImage = data?.assigned_to_user?.last_name[0];
    const assigneeName = `${assigneeFirstName || ""}${assigneeLastImage || ""}`;
    const assigneetooltipName = `${data?.assigned_to_user?.first_name || ""} ${data?.assigned_to_user?.last_name || ""
      }`;

      const handleAssignClick = useCallback( () => {
        assignCardMutate({
          card_id: cardId,
          data: {
            assigned_to_user_id: currentUserId(),
          },
        });
      },[assignCardMutate, cardId, currentUserId]);

  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Assignee</p>
        <div className="assignee-detail taskdetail-sidebar-right-col">
          <div className="assignee-image">
            <AssignCard
              tooltipName={data?.assigned_to_user && assigneetooltipName }
              project={data}
              name={data?.assigned_to_user && assigneeName}
              assigneeOptions={assigneeOptions}
              accessForAssign={conditionCheck ||  boardPermission?.can_reassign_user ||data?.assigned_to_user_id == currentUserId() }
              cardId={cardId}
            />
          </div>
          <div className="assignee">
            <div className="assignee-name">
              {data?.assigned_to_user && (
                <p>{`${data?.assigned_to_user?.first_name} ${data?.assigned_to_user?.last_name}`}</p>
              )}
            </div>
            <div className="sidebar-assigntome-btn">
              {!data?.assigned_to_user && (
                <CustomButton
                  className="reset-btn"
                  onClick={handleAssignClick}
                >
                  Assign to me
                </CustomButton>
              )}
            </div>
          </div>
        </div>
      </Grid>
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return (
    prevProps.data?.assigned_to_user === nextProps.data?.assigned_to_user
    &&
    prevProps.data?.assigned_to_user?.first_name === nextProps.data?.assigned_to_user?.first_name
    &&
    prevProps.data?.assigned_to_user?.last_name === nextProps.data?.assigned_to_user?.last_name
    &&
    prevProps.data?.assigned_to_user_id === nextProps.data?.assigned_to_user_id
    &&
    prevProps.assigneeOptions?.map((user) => user?.user_id)?.join(",") === nextProps.assigneeOptions?.map((user) => user?.user_id)?.join(",")
    &&
    prevProps.conditionCheck === nextProps.conditionCheck 
    &&
    prevProps.cardId === nextProps.cardId
    &&
    prevProps.assignCardMutate === nextProps.assignCardMutate
    &&
    prevProps.currentUserId === nextProps.currentUserId
  )
}
export default React.memo(AssigneeSection, arePropsEqual);
